export default {
  'promoHeader': 'Har du husket?',
  'add':'Legg til',
  'pickSize':'Velg størrelse',
  'cartHeader':'Handlekurv:',
  'addUniid':'Legg til navn og nummer',
  'remove':'Fjern',
  'freeDelivery':'Kult, du har fått gratis frakt!',
  'toCheckout':'Fortsett til betaling',
  'totalPrice':'Totalt:',
  'totalDiscount':'Samlet rabatt:',
  'deliveryPrice':'Leveringspris:',
  'size':'Størrelse:',
  'getTomoz':'',
  'totalVAT':'Moms totalt:',
  'consent': 'Yes - I allow Unisport to send me email and sms\'s on similar football products. I can unsubscribe at any time in the email or by un-ticking this box, should the communication not be as expected.'
}